import {
  title,
  description,
  mrAuto,
  mlAuto
} from "assets/jss/material-kit-pro-react.jsx";

const servicesStyle = {
  title,
  mrAuto,
  mlAuto,
  services: {
    paddingTop: "10px",
    paddingBottom: "80px"
  },
  textCenter: {
    textAlign: "center"
  },
  description
};

export default servicesStyle;
